module.exports = __webpack_public_path__ + "static/media/empty_goals_tabby.a9c3b3e7.png";